import {
    CANCEL_SERVICE_PLAN_ERROR,
    CANCEL_SERVICE_PLAN_START,
    CANCEL_SERVICE_PLAN_SUCCESS,
    SERVICE_PLAN_PAYMENT_ERROR,
    SERVICE_PLAN_PAYMENT_START,
    SERVICE_PLAN_PAYMENT_SUCCESS
} from "../../../constants";

import { sendStripePayment } from "../../../core/servicePlan/payment/stripe/sendStripePayment";
import { cancelPurchaseServicePlan, createPurchaseServicePlan, getServicePlanPaymentStatus as query } from "../../../lib/graphql";
import showToaster from "../../../helpers/toasterMessages/showToaster";
import { convert, getFixedValue } from "../../../helpers/currencyConvertion";
import { sendPaypalPayment } from "../../../core/servicePlan/payment/paypal/sendPaypalPayment";
import { loadAccount } from "../../account";
import { getServiceFees } from "../../ServiceFees/getServiceFees";

export function makeServicePlanPaymentAction(values, paymentMethodId) {
    return async (dispatch, getState, { client }) => {

        dispatch({ type: SERVICE_PLAN_PAYMENT_START });

        try {
            const { data } = await client.mutate({
                mutation: createPurchaseServicePlan,
                variables: {
                    price: Number(values?.price),
                    currency: values?.currency,
                    userType: values?.userType,
                    startDate: values?.startDate,
                    endDate: values?.lateDate,
                    serviceFee: Number(values?.serviceFee),
                    duration: values?.duration,
                    servicePlanId: values?.servicePlanId,
                    servicePlanName: values?.servicePlanName,
                    serviceDescription: values?.serviceDescription,
                    serviceAIFeature: values?.serviceAIFeature,
                    paymentType: Number(values?.paymentType)
                }
            });

            if (data?.createPurchaseServicePlan?.status === 200) {

                const purchaseServicePlanData = data?.createPurchaseServicePlan?.result;

                let servicePlanId = purchaseServicePlanData?.id, amount = getFixedValue(purchaseServicePlanData?.price), rates = getState().currency.rates;
                let isAmount = 0;
                let baseCurrency = getState().currency.base, convertedAmount = 0, overAllAmount = amount && amount.toString().split(".");

                if (overAllAmount && overAllAmount[1] == "00") {
                    isAmount = overAllAmount && overAllAmount[0];
                } else {
                    isAmount = amount;
                }

                if (values?.paymentType == 1) {
                    convertedAmount = getFixedValue(convert(baseCurrency, rates, isAmount, purchaseServicePlanData?.currency, values?.paymentCurrency));
                    const { status, errorMessage } = await sendPaypalPayment({ servicePlanId, amount: convertedAmount, currency: values?.paymentCurrency, description: purchaseServicePlanData?.servicePlanName, userType: purchaseServicePlanData?.userType, userId: purchaseServicePlanData?.userId });

                    if (status === 200) {
                        await dispatch({
                            type: SERVICE_PLAN_PAYMENT_SUCCESS,
                        });
                        await dispatch(loadAccount())
                        await dispatch(getServiceFees({ listId: purchaseServicePlanData?.listId }))
                    } else {
                        if (status === 422) {
                            showToaster({ messageId: 'invalidCurrency', toasterType: 'error' })
                        }
                        else {
                            errorMessage ? showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: errorMessage }) : '';
                        }
                        await dispatch({
                            type: SERVICE_PLAN_PAYMENT_ERROR,
                        });
                    }
                } else {
                    const planDetails = {
                        servicePlanId: purchaseServicePlanData?.id,
                        userId: purchaseServicePlanData?.userId,
                        planName: purchaseServicePlanData?.servicePlanName,
                        amount: purchaseServicePlanData?.price,
                        currency: purchaseServicePlanData?.currency,
                        userType: purchaseServicePlanData?.userType,
                        listId: purchaseServicePlanData?.listId
                    };
                    const cardDetails = {};

                    const { status, errorMessage, paymentIntentSecret } = await sendStripePayment({
                        type: "servicePlanStripe",
                        cardDetails,
                        planDetails,
                        paymentMethodId
                    });

                    if (status === 200) {
                        await dispatch(loadAccount())
                        await dispatch(getServiceFees({ listId: purchaseServicePlanData?.listId }))
                        dispatch({ type: SERVICE_PLAN_PAYMENT_SUCCESS });
                        return { status };
                    } else {
                        errorMessage ? showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: errorMessage }) : '';
                        await dispatch({
                            type: SERVICE_PLAN_PAYMENT_ERROR,
                        });
                        await dispatch(loadAccount())
                        await dispatch(getServiceFees({ listId: purchaseServicePlanData?.listId }))
                        return {
                            status,
                            paymentIntentSecret,
                            purchaseServicePlanData
                        }
                    }

                }

            } else {
                dispatch({ type: SERVICE_PLAN_PAYMENT_ERROR });
                showToaster({
                    messageId: "commonError",
                    requestMessage: data?.createPurchaseServicePlan?.errorMessage,
                    toasterType: "error"
                });
            }

        } catch (error) {
            dispatch({ type: SERVICE_PLAN_PAYMENT_ERROR });
            showToaster({
                messageId: "updateFailed",
                toasterType: "error"
            });
        }
    };
}



export function processCardAction({ servicePlanId, userId, confirmPaymentIntentId, amount, userType, listId }) {

    return async (dispatch, getState, { client }) => {

        dispatch({ type: SERVICE_PLAN_PAYMENT_START });

        try {
            let planDetails = {
                userId,
                servicePlanId,
                amount,
                userType,
                listId
            }

            const { status, errorMessage } = await sendStripePayment({
                type: 'confirmServicePlanStripe',
                planDetails,
                confirmPaymentIntentId
            });

            if (status && status == 200) {
                dispatch({ type: SERVICE_PLAN_PAYMENT_SUCCESS });
                await dispatch(loadAccount())
                await dispatch(getServiceFees({ listId }))
                return {
                    status,
                    errorMessage
                }
            } else {
                showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: errorMessage })
                dispatch({ type: SERVICE_PLAN_PAYMENT_ERROR });
            }

        } catch (error) {
            dispatch({ type: SERVICE_PLAN_PAYMENT_ERROR });
            return false;
        }
        return true;
    };
}


export function cancelPurchaseServicePlanAction(id) {
    return async (dispatch, getState, { client }) => {
        dispatch({ type: CANCEL_SERVICE_PLAN_START });
        try {
            const { data } = await client.mutate({
                mutation: cancelPurchaseServicePlan,
                variables: { id },

            });
            if (data?.cancelPurchaseServicePlan?.status == 200) {
                dispatch({
                    type: CANCEL_SERVICE_PLAN_SUCCESS
                });
                await dispatch(loadAccount())
                await dispatch(getServiceFees())
                showToaster({
                    messageId: 'cancelPurchaseServicePlansSuccess',
                    toasterType: 'success'
                });
                return true;
            } else {
                dispatch({
                    type: CANCEL_SERVICE_PLAN_ERROR
                });
                showToaster({
                    messageId: 'commonError',
                    toasterType: 'error',
                    requestContent: data?.cancelPurchaseServicePlan?.errorMessage
                })
            }

        } catch (error) {
            dispatch({
                type: CANCEL_SERVICE_PLAN_ERROR
            });
            showToaster({
                messageId: 'updateFailed',
                toasterType: 'error'
            })
        }
    }
};

export function makeServicePlanReturnPaymentAction(values) {
    return async (dispatch, getState, { client }) => {

        await dispatch({ type: SERVICE_PLAN_PAYMENT_START });
        try {
            const { data } = await client.query({
                query,
                variables: {
                    id: Number(values?.id),
                },
                fetchPolicy: 'network-only'

            });

            if (data?.getServicePlanPaymentStatus?.status === 200) {
                let purchaseServicePlanData = data?.getServicePlanPaymentStatus?.result
                let servicePlanId = purchaseServicePlanData?.id, amount = getFixedValue(purchaseServicePlanData?.price), rates = getState().currency.rates;
                let isAmount = 0;
                let baseCurrency = getState().currency.base, convertedAmount = 0, overAllAmount = amount && amount.toString().split(".")

                if (overAllAmount && overAllAmount[1] == "00") {
                    isAmount = overAllAmount && overAllAmount[0];
                } else {
                    isAmount = amount;
                }

                if (values?.paymentType == 1) {
                    convertedAmount = getFixedValue(convert(baseCurrency, rates, isAmount, purchaseServicePlanData?.currency, values?.paymentCurrency));
                    const { status, errorMessage } = await sendPaypalPayment({ servicePlanId, amount: convertedAmount, currency: values?.paymentCurrency, description: purchaseServicePlanData?.servicePlanName, userType: purchaseServicePlanData?.userType, userId: purchaseServicePlanData?.userId });
                    if (status === 200) {
                        await dispatch({ type: SERVICE_PLAN_PAYMENT_SUCCESS });
                        await dispatch(loadAccount())
                        return;
                    }

                    status === 422
                        ? showToaster({ messageId: 'invalidCurrency', toasterType: 'error' })
                        : errorMessage && showToaster({ messageId: 'commonError', toasterType: 'error', requestContent: errorMessage });

                    await dispatch({ type: SERVICE_PLAN_PAYMENT_ERROR });
                }

            }

        } catch (error) {
            dispatch({
                type: SERVICE_PLAN_PAYMENT_ERROR
            });
            showToaster({ messageId: 'updateFailed', toasterType: 'error' })
        }
    }
};
